import React, { useEffect, useState } from 'react';
import settings from '../../data/settings';
import { useMediaQuery } from 'react-responsive';

const CloseButton = ({ isOpen, toggleMenu }) => {
  const [marginLeft, setMarginLeft] = useState('2rem');
  const isSmallScreen = useMediaQuery({ maxWidth: 640 });
  const isMediumScreen = useMediaQuery({ minWidth: 641, maxWidth: 1023 });

  // const onButtonClick = () => {
  //   // setIsCloseButtonVisible(!isOpen);
  //   setTimeout(() => {
  //     setButtonBackgroundColor(isOpen ? '#fff' : '333');
  //   }, 500);
  // };

  useEffect(() => {
    const calculateMargin = () => {
      const fontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );
      const desiredDistanceFromRightEdge = 2 * fontSize;
      const buttonWidth = 67;
      const windowWidth = window.innerWidth;
      const newMarginLeft =
        windowWidth - buttonWidth - desiredDistanceFromRightEdge;
      if (settings.alignment.navigation === 'right') {
        setMarginLeft(`${newMarginLeft}px`);
      }
    };

    calculateMargin();
    window.addEventListener('resize', calculateMargin);
  }, [marginLeft]);

  return (
    <div
      className='menuButtonContainer'
      style={{
        cursor: 'pointer',
        marginLeft: marginLeft,
        position: isOpen === true ? 'fixed' : 'inherit',
        top: isOpen ? '2rem' : '0',
        pointerEvents: 'auto',
      }}
    >
      <div
        className={`menuButton ${isOpen ? 'openmenu' : ''}`}
        onClick={toggleMenu}
        style={{
          marginLeft:
            isSmallScreen && settings.alignment.navigation === 'right'
              ? '1.5rem'
              : isSmallScreen && settings.alignment.navigation === 'left'
              ? '-1rem'
              : null,
        }}
      >
        <div
          className='menu-icon'
          style={{
            marginTop: '2rem',
            zIndex: 100000000000000,
            position: isOpen && 'fixed',
          }}
        >
          <span className='line-1'></span>
          <span className='line-2'></span>
          <span className='line-3'></span>
        </div>
      </div>
    </div>
  );
};

export default CloseButton;
